import React, {useState} from 'react'
import Button2 from '../../NewComponent/Button2/Button2'
import SelectComp from '../../NewComponent/Select/Select'
import { useSelector, useDispatch } from 'react-redux';
import {ReactComponent as CopyIcon} from '../../Icons/copy.svg';
import {ReactComponent as ATTIcon} from '../../Icons/att.svg';
import { generateAIText, requestForUpdate } from '../../API/api';
import { bindActionCreators } from 'redux';
import { Actions } from '../../Action';
import { message } from 'antd';
import {ReactComponent as UnionIcon} from '../../Icons/Union.svg';
import Voting from '../../NewComponent/Voting/Voting';
import { toast } from "react-toastify";
import { CURRENT_ROLE } from '../../API/url';
import {ReactComponent as FireIcon} from '../../Icons/fire.svg';
import TooltipComp from '../../NewComponent/ToolTip/TooltipComp';
import { useNavigate } from 'react-router-dom';

export default function GenAiButtonSection() {
  const [messageApi, contextHolder] = message.useMessage();
  const [isAcc, setAcc] = useState(null);
  const userState = useSelector(state=>state.user);
  const searchState = useSelector(state=>state.search);
  const navigate = useNavigate();
  const [permission, setPermission] =useState(userState.roles.find(data=>data.roleName===CURRENT_ROLE).permissions.find(item=>item.id===4));
  const dispatch = useDispatch();
  const {updateLanguageSP, UpdateGenerativeAITextWithDiffLang, isRegeneratingGenAiText, advanceFilterModalToggle,isExternalSearchAllowed,briefQueryChange, briefisInputShowChange, briefFromSeaerchChange} = bindActionCreators(Actions, dispatch)
  const funcCon =(arr)=>{
    let newArr = [];
    arr.filter(ar=>{
      let obj={
        value:ar,
        label:ar
      }
      newArr.push(obj);
    });
    return newArr;
  }
  const success = () => {
    messageApi.open({
      type: 'success',
      content: 'Text copied!',
      position:'top-right'
    });
  };
  const onChangeFunc=(e)=>{
    updateLanguageSP(e);
    isRegeneratingGenAiText(true);
    const payload = {
      question:searchState.inputValue,
      language: e,
      salesSummary:searchState.isSalesSummary==='Technical'?false:true,
      shortSummary:searchState.isShortChecked==='Detailed'?false:true,
      generatedText: searchState.origGenerativeText
    }
    generateAIText(payload).then(res=>{
      if (res===undefined) return;
      UpdateGenerativeAITextWithDiffLang(res.data.data);
      isRegeneratingGenAiText(false);
    })
  }
  const stripHtml=(htmlString)=>{
    return htmlString
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<\/p>/gi, "\n\n")
    .replace(/<\/?[^>]+(>|$)/g, "");
  }
const onClickCopy=()=>{
  toast.success(successfulHelpful('Text copied!'), {
    position: toast.POSITION.TOP_RIGHT,
  });
  let newString = stripHtml(searchState.generativeText);
  navigator.clipboard.writeText(newString);
}
const onClickAcceptReject=()=>{
}
const getSummaryUuid = (data) => {
  let uuid ='';
  data.filter(obj=>{
    if(obj.summaryUuidStr !== undefined && obj.summaryUuidStr !== null){
      uuid = obj.summaryUuidStr;
    }
  })
  return uuid;
}

const onClickAccRej=(key)=>{
    setAcc(key);
    const helpfulAPIPayload = {
      questionUuid: '',
      answerUuid: '',
      status: key===1?"accepted":'reject',
      questionText: '',
      answerText: '',
      botQuestionText: '',
      pdfId: "",
      summaryUuidStr:getSummaryUuid(searchState.origSearchData)
    };
    helpfulTrigger(helpfulAPIPayload);
}
const onClickAsk=()=>{
  advanceFilterModalToggle({ bool: true, value: "askTheTeam" })
}
const onClickExternal=()=>{
  isExternalSearchAllowed(!searchState.isExternal);
}
const onClickAgent=()=>{
  briefFromSeaerchChange(true);
  briefisInputShowChange(0);
  briefQueryChange(searchState.inputValue);
  navigate('/seekerHome/brief');
}
// console.log(searchState);
const helpfulTrigger = (payload) => {
  requestForUpdate(payload)
    .then((res) => {
      if (res !== undefined) {
        toast.success(successfulHelpful(res.data.message), {
          position: toast.POSITION.TOP_RIGHT,
        });
        
      }
    })
    .catch((err) => {});
};

const successfulHelpful = (message) => {
  return (
    <>
      <span style={{ fontSize: "12px" }}>{message}</span>
    </>
  );
};
  return (
    <>
    {contextHolder}
    <div style={{height:'80px', borderTop:'1px solid #E0E2E6','boxShadow': '0px -2px 4px 0px #34405414', padding:'24px 35px 24px 35px', display:'flex',justifyContent:'space-between', alignItems:'center'}}>
        {!searchState.isLoading && <div style={{display:'flex'}}>{searchState.origGenerativeText!=="" && !searchState.isLoading && <><Button2 type={'light'} onClickFunc={onClickCopy} ><CopyIcon/></Button2>&nbsp;</>}{permission !== undefined && <Button2 type={'dark'} onClickFunc={onClickAsk}><ATTIcon/>&nbsp;Ask the team</Button2>}{userState.usedBriefCount !== userState.briefThreshold && <>&nbsp;&nbsp;<Button2 onClickFunc={onClickAgent} type='dark'>Agent Mode</Button2></>}</div>}
        {searchState.origGenerativeText!=="" && !searchState.isLoading && <div style={{display:'flex'}}><SelectComp width={'120px'} onChangeFunc={onChangeFunc} isString={false} val={searchState.lang} options={funcCon(userState.multipleLanguages)} size={'large'} />&nbsp;{!searchState.isExternal && <Button2 onClickFunc={onClickAcceptReject} type={'light'}><Voting value={isAcc} onClickFunc={onClickAccRej} /></Button2>}</div>}
    </div>
    </>
  )
}
